import { axios } from '@/utils/request'
import { sysInfo } from '@/config'
import { dragDeviceType } from '@/api/deviceType'

// 获取特性树
export function getEquipmentTree (parameter) {
  return axios({
    url: sysInfo.apiRemote + '/equipmentPeculiarity/tree',
    method: 'GET',
    params: parameter
  })
}
// 获取特性详情
export function getEquipmentDetail (parameter) {
  return axios({
    url: sysInfo.apiRemote + `/equipmentPeculiarity/${parameter.id}`,
    method: 'GET'
  })
}
// 保存特性参数
export function saveEquipmentParameters (parameter) {
  return axios({
    url: sysInfo.apiRemote + '/equipmentPeculiarity/save',
    method: 'POST',
    data: parameter
  })
}
// 编辑特性参数
export function editEquipmentParameters (parameter) {
  return axios({
    url: sysInfo.apiRemote + '/equipmentPeculiarity/edit',
    method: 'PUT',
    data: parameter
  })
}
// 删除特性参数
export function delEquipmentParameters (parameter) {
  return axios({
    url: sysInfo.apiRemote + '/equipmentPeculiarity/delete',
    method: 'DELETE',
    data: parameter
  })
}
// 拖拽特性参数树节点
export function dragEquipmentParameters (parameter) {
  return axios({
    url: sysInfo.apiRemote + '/equipmentPeculiarity/drag',
    method: 'PUT',
    data: parameter
  })
}
// 获取图标
export function getIcon (parameter) {
  return axios({
    url: sysInfo.apiRemote + '/dict/query',
    method: 'GET',
    params: parameter
  })
}
